import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "team", "showImage"];
import React from 'react';
import TeamMember from '../../molecules/TeamMember';
import { GatsbyImagePropType } from '../../services/proptypes';
import ItemCollection from '../ItemCollection';
var defaultProps = {
  as: 'horizontalItem',
  buttonBasic: false,
  buttonSize: 'medium',
  cardInlinePhoto: false,
  centerHeader: false,
  header: 'Our Team',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  itemsDivided: false,
  itemsPerRow: 3,
  link: '',
  linkAs: 'none',
  linkContent: '',
  onlyEvenRows: false,
  showImage: true,
  verticalItemAlign: 'center'
};
export default function Team(_ref) {
  var as = _ref.as,
    team = _ref.team,
    showImage = _ref.showImage,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ItemCollection, _extends({
    collectionType: as === 'horizontalItem' ? 'items' : 'custom'
  }, rest), team.map(function (member) {
    var id = member._id,
      name = member.name,
      image = member.image,
      gatsbyImage = member.gatsbyImage;
    return /*#__PURE__*/React.createElement(TeamMember, _extends({
      key: id + name
    }, member, {
      as: as
    }, rest, {
      image: showImage ? gatsbyImage && gatsbyImage.childImageSharp || image : ''
    }));
  }));
}
Team.defaultProps = defaultProps;